export default "__VITE_ASSET__CvSk$wG8__"